/**
 * Full-map control dimensions, shared by the visual control and its layout.
 *
 * Android's Mapbox TextureView owns its own input surface, so these controls
 * are mounted as an elevated native sibling in the screen — never emulated by
 * interpreting a Mapbox canvas coordinate.
 */
export const MAP_CHROME_CONTROL_SIZE = 52
export const MAP_CHROME_RESULTS_HEIGHT = 48
